import React from "react";
import { Button, Space, Select } from "antd";

import ProcessingButton from "@/components/ui/ProcessingButton";

const SelectPage = ({
  projects,
  reportTemplates,
  selectedProjectId,
  setSelectedProjectId,
  selectedReportTemplateId,
  setSelectedReportTemplateId,
  selectsDisabled,
  handleTemplateGeneration,
}) => {
  const sortedProjects = [...projects].sort((a, b) => a.name.localeCompare(b.name));
  const selectedReportTemplate = reportTemplates.find((template) => template.id === selectedReportTemplateId);

  return (
    <div className="template_selection_wrapper">
      <div className="template_selection_picker">
        <div>
          <div className="template_selection_title" style={{ marginBottom: "0.25rem" }}>Select a Project</div>
          <Select
            showSearch
            className="template_selection_select"
            placeholder="Select project"
            value={selectedProjectId}
            onChange={(value) => {
              setSelectedProjectId(value);
              setSelectedReportTemplateId(null);
            }}
            disabled={selectsDisabled}
            optionFilterProp="children"
          >
            {sortedProjects.map((project) => (
              <Select.Option key={project.id} value={project.id}>
                {project.name}
              </Select.Option>
            ))}
          </Select>
        </div>

        {selectedProjectId && selectedReportTemplateId && (
          <div>
            <div className="template_selection_title" style={{ marginBottom: "0.25rem" }}>Assigned Report</div>
            <div
              className="home_dropdown_readonly_value"
              style={{ width: "100%", minWidth: "unset", textAlign: "center" }}
            >
              {selectedReportTemplate?.name || "No report template available"}
            </div>
          </div>
        )}

        <div>
          <ProcessingButton
            onClick={() => handleTemplateGeneration()}
            processingText="Generating Template..."
            frameClassName="template_selection_processing_frame"
            renderButton={({ onClick, disabled, className, isProcessing }) => (
              <Button
                className={`${className} template_selection_button ${
                  selectedReportTemplateId === null || selectedProjectId === null ? "disabled" : ""
                }`}
                onClick={onClick}
                disabled={disabled || selectedReportTemplateId === null || selectedProjectId === null}
              >
                <Space size={6}>
                  <img
                    src="/assets/icon-32.png"
                    alt="Section Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <span className={isProcessing ? "ai-processing-label" : undefined}>
                    {isProcessing ? "Generating Template..." : "Generate Template"}
                  </span>
                </Space>
              </Button>
            )}
          />
          <p
            style={{
              color: "#d1d1d1",
              fontSize: "10px",
              textAlign: "center",
              margin: 0,
              marginTop: "6px",
              marginBottom: "12px",
            }}
          >
            AI-generated content may be incorrect
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelectPage;
